import { Injectable } from '@angular/core';
import { GraphClientService } from '../../../services/graph-client-service';
import { MsalService, BroadcastService } from '@azure/msal-angular';
import { DiagnosticsServiceFactory } from '../../../services/diagnostics-service-factory';
import { GRAPH_SCOPES } from '../../../msal.constants';
import { Observable, of, from } from 'rxjs';
import { catchError, map, flatMap } from 'rxjs/operators';


/**
 * Facilitates tracking of user actions.
 * */
@Injectable({ providedIn: 'root' })
export class BackBeaconService {
  private graphClient: GraphClientService;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    private authService: MsalService,
    graphClient: GraphClientService) {
    this.graphClient = graphClient;
  }

  getEmailOrAnonymous(): Observable<any> {
    let auth = from(this.authorize(GRAPH_SCOPES));

    var resp = auth.pipe(
      flatMap((token: string) => {
        return this.graphClient.getData('GreeterComponent', token).pipe(
          flatMap((data: any) => of(data.mail)),
          catchError(_ => of('Anonymous'))
        );
      }),
      catchError(_ => of('Anonymous'))
    );

    return resp;
  }

  track(action: string): void {
    this.getEmailOrAnonymous().subscribe(email => {
      var f = (<any>document.getElementById("blt")).contentWindow;

      let parameters: string = '';

      parameters += "action=trackbeacon";
      parameters += "&pageToken=" + window.location.href;
      parameters += "&campaignId=" + 7;
      parameters += "&actionId=" + action;
      parameters += "&attributeId=" + 'userEmail';
      parameters += "&attrValue=" + email;

      f.postMessage(parameters, "*");
    });
  }

  protected authorize(scopes: string[]): Promise<any> {
    return this.authService.acquireTokenSilent(scopes);
  }
}
